import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "../../components/header";
import Post from "../../components/post";
import axios from "axios";
import "./style.css";

export default function PostDetail() {
  const { postId } = useParams();
  const { user } = useSelector((state) => ({ ...state }));
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const { data } = await axios.get(`/getPost/${postId}`, {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        });
        setPost(data);
      } catch (error) {
        setError("Post not found or you don't have permission to view it");
        console.error("Error fetching post:", error);
      } finally {
        setLoading(false);
      }
    };

    if (postId && user.token) {
      fetchPost();
    }
  }, [postId, user.token]);

  if (loading) {
    return (
      <>
        <Header 
          showMessengerSidebar={false}
          onMessengerToggle={() => {}}
        />
        <div className="post_detail_page">
          <div className="post_detail_container">
            <div className="loading">Loading post...</div>
          </div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header 
          showMessengerSidebar={false}
          onMessengerToggle={() => {}}
        />
        <div className="post_detail_page">
          <div className="post_detail_container">
            <div className="error_message">
              <h3>Post not found</h3>
              <p>{error}</p>
              <button 
                className="blue_btn" 
                onClick={() => navigate("/")}
              >
                Go back to Home
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Header 
        showMessengerSidebar={false}
        onMessengerToggle={() => {}}
      />
      <div className="post_detail_page">
        <div className="post_detail_container">
          <div className="post_detail_header">
            <button 
              className="back_btn" 
              onClick={() => navigate(-1)}
            >
              ← Back
            </button>
            <h2>Publication</h2>
          </div>
          {post && (
            <Post 
              post={post} 
              user={user} 
              profile={false}
            />
          )}
        </div>
      </div>
    </>
  );
} 